module.exports = require("@wordpress/html-entities");